import Flex from '@Components/Bases/Flex';
import { IESGDetails } from '@Domains/Progress';
import { CheckCircle } from '@mui/icons-material';
import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';
import { Box, Button, Typography } from '@mui/material';
import { formatDate } from '@Utils/datetime';

type DataPlatformProps = {
  esg?: IESGDetails;
  reportId?: number;
  isPublished: boolean;
};

const DataPlatformSection = ({
  esg,
  reportId,
  isPublished,
}: DataPlatformProps) => {
  const handleEdit = () => {
    window.location.href = `/report/${reportId}/esg-plans/platform`;
  };

  const { updateDate } = esg?.esgDataPlatform || {};

  return (
    <Flex flexDirection="row" p={1}>
      <Flex p={1}>
        {esg?.esgDataPlatform?.isSectionCompletedTh ? (
          <CheckCircle
            sx={(theme) => ({ color: theme.palette.success.main })}
          />
        ) : (
          <AccessTimeFilledIcon
            sx={(theme) => ({
              color: theme.palette.secondary.lighter,
            })}
          />
        )}
      </Flex>
      <Box width={1}>
        <Flex flexDirection="row" justifyContent="space-between">
          <Typography>เปิดเผยข้อมูลจาก ESG Data Platform</Typography>
          <Button
            variant="text"
            color="info"
            sx={{ fontWeight: 400 }}
            onClick={handleEdit}
          >
            {isPublished ? 'ดูข้อมูล' : 'แก้ไขข้อมูล'}
          </Button>
        </Flex>
        <Typography variant="caption">
          วันที่อัปเดต:{' '}
          {updateDate ? formatDate(new Date(updateDate), 'th-TH') : '-'}
        </Typography>
      </Box>
    </Flex>
  );
};

export default DataPlatformSection;
